import { lazy, ComponentType } from "react";

/**
 * Wraps React.lazy with automatic retry + page reload for stale chunk errors.
 * After a deploy, browsers may still reference old chunk filenames that no longer exist.
 */
export function lazyRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory().catch((err) => {
      // If we haven't already tried reloading, do a hard reload
      const key = "chunk-reload";
      const hasReloaded = sessionStorage.getItem(key);
      if (!hasReloaded) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        // Return a never-resolving promise so React doesn't render an error
        return new Promise<{ default: T }>(() => {});
      }
      sessionStorage.removeItem(key);
      throw err;
    })
  );
}
